import planet from "../../Utils/Assets/Icons/planet.svg";
import styles from "./style.module.scss";

const WorldOfMetaverse = () => {
    const items = (
      <>
        <h3>PHYGITAL ECOSYSTEM</h3>
        <img src={planet} alt="Planet" />
        <h3>WORLD OF METAVERSE</h3>
        <img src={planet} alt="Planet" />
        <h3>PHYGITAL ECOSYSTEM</h3>
        <img src={planet} alt="Planet" />
        <h3>WORLD OF METAVERSE</h3>
        <img src={planet} alt="Planet" />
        <h3>PHYGITAL ECOSYSTEM</h3>
        <img src={planet} alt="Planet" />
        <h3>WORLD OF METAVERSE</h3>
        <img src={planet} alt="Planet" />
      </>
    );

    return (
      <>
        <div className={styles.worldOfMetaverse}>
          <div className={styles.marqueeTrack}>
            {items}
            {items}
          </div>
        </div>

        <div className={`${styles.worldOfMetaverse} ${styles.secondary}`}>
          <div className={styles.marqueeTrack}>
            {items}
            {items}
          </div>
        </div>
      </>
    );
};

export default WorldOfMetaverse;
